import { DtoBase } from "../DtoBase";
import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { AgentMonitorPolicyDto } from './AgentMonitorPolicyDto';


export class GetAgentMonitorPoliciesResultDto extends DtoBase {

	public MonitorPolicyGuids: List<string>;
	public MonitorPolicies: List<AgentMonitorPolicyDto>;
	public MonitorPolicyStates: List<string>;

	constructor() {
		super();

		this.MonitorPolicyGuids = new List<string>();
		this.MonitorPolicies = new List<AgentMonitorPolicyDto>();
		this.MonitorPolicyStates = new List<string>();
	}

	public get HasMonitorPolicyGuids(): boolean {
		return (!!this.MonitorPolicyGuids && this.MonitorPolicyGuids.Count > 0);
	}

	public get HasMonitorPolicies(): boolean {
		return (!!this.MonitorPolicies && this.MonitorPolicies.Count > 0);
	}

	public get HasMonitorPolicyStates(): boolean {
		return (!!this.MonitorPolicyStates && this.MonitorPolicyStates.Count > 0);
	}

	public Write(obj: any, context: any): void {
		obj.get_agent_monitor_policies_result = {};
		obj = obj.get_agent_monitor_policies_result;

		super.Write(obj, context);

		if (this.HasMonitorPolicyGuids) {
			obj.monitor_policy_guids = [];
			ObjSerUtils.WriteStringValueCollection(obj.monitor_policy_guids, this.MonitorPolicyGuids, context);
		}

		if (this.HasMonitorPolicies) {
			obj.monitor_policies = [];
			ObjSerUtils.WriteObjSerCollection(obj.monitor_policies, this.MonitorPolicies, context);
		}

		if (this.HasMonitorPolicyStates) {
			obj.monitor_policy_states = [];
			ObjSerUtils.WriteStringValueCollection(obj.monitor_policy_states, this.MonitorPolicyStates, context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.get_agent_monitor_policies_result)
			throw new Error();
		obj = obj.get_agent_monitor_policies_result;

		super.Read(obj, context);

		if (obj.monitor_policy_guids !== undefined) {
			this.MonitorPolicyGuids.Clear();
			ObjSerUtils.ReadStringValueCollection(obj.monitor_policy_guids, this.MonitorPolicyGuids, context);
		}

		if (obj.monitor_policies !== undefined) {
			this.MonitorPolicies.Clear();
			ObjSerUtils.ReadObjSerCollection(obj.monitor_policies, this.MonitorPolicies,
				(value: any) => new AgentMonitorPolicyDto(), context);
		}

		if (obj.monitor_policy_states !== undefined) {
			this.MonitorPolicyStates.Clear();
			ObjSerUtils.ReadStringValueCollection(obj.monitor_policy_states, this.MonitorPolicyStates, context);
		}
	}

}